import React from "react";
import styled, { keyframes } from "styled-components";
import {MdOutlineClose} from 'react-icons/md'

const CustomModal = (props) => {
  return (
    <Wrapper>
      <MainContent>
        <Summary>
          <Header>
            <label htmlFor={props.label}>{props.label}</label>
            <MdOutlineClose onClick={props.showHide} />
          </Header>
          <Body>
          {props.children}
          </Body>
          <Footer>
            <button onClick={props.showHide} className="btn btn-outline-primary">Close</button>
            <button className="btn btn-primary" onClick={props.saveFunction}>{props.buttonName ? props.buttonName : 'Save changes'}</button>
          </Footer>
        </Summary>
      </MainContent>
    </Wrapper>
  );
};

const appear = keyframes`
0%{
  opacity: 1;
  transform: translateY(-10px)
}
`

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
  overflow-x: hidden;
  display: flex;
  height: 100%;
  width: 100%;
  animation: ${appear} 0.25s linear;
`;
const MainContent = styled.div`
  width: 75%;
  height: auto;
  background-color: #fff;
  display: flex;
  margin: auto;
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: 4px;
  position: relative;

`;

const Summary = styled.div`
  height: 100%;
  width: 100%;
`;
const Header = styled.div`
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.25rem;
margin-bottom: 0.5rem;

  & > svg {
    cursor: pointer;
    font-size: 1rem;
    font-weight: bolder;
    &:hover {
      color: rgba(0, 0, 0, 0.4);
      transition: all 0.1s linear;
    }
  }
`;
const Body = styled.div`
  border-width: 2px 0 2px 0;
  border-style: solid;
  border-color: rgba(0,0,0,0.025);
  padding: 1rem;
`
const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem ;

  
`



export default CustomModal;
